// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mKX8","selected":"styles_selected__20Q67"};